import produce from 'immer';
import create from 'zustand';

import { getClosestFirstSeptember, getClosestLastMay } from 'utils/Helpers';
import { generateStudyPlan } from 'utils/StudyPlan';

// Initial store value
const GRADE_STUDENT_INITIAL = {
	// Request data
	data: {
		gradeId: 0,
		blankId: 0,
		direction: '',
		startDate: getClosestFirstSeptember(0),
		endDate: getClosestLastMay(getClosestFirstSeptember(0)),
		courses: []
	},

	// Collected grades and blanks
	grades: [],
	blanks: []
};

export const useGradeStudentsTransferStore = create((set, get) => ({
	...GRADE_STUDENT_INITIAL,

	// Handle data change
	onChange: ({ name, value }) => set(produce(state => {
		state.data[name] = value;
		if (name === 'blankId') {
			const blank = state.blanks.find(blank => blank.id === +value);
			state.data.courses = blank?.courses ?? [];
		}
	})),

	// Handle course date change
	onChangeCourse: (id, { name, value }) => set(produce(state => {
		const course = state.data.courses.find(c => c.id === id);
		course[name] = value;
		if (course.exam) course.exam[name] = value;
	})),

	// Handle course removal
	onRemoveCourse: (id) => set(produce(state => {
		state.data.courses = state.data.courses.filter(c => c.id !== id);
	})),

	// Handle plan generation
	onGenerate: () => set(produce(state => {
		state.data.courses = generateStudyPlan(get().data.startDate, get().data.endDate, get().data.courses);
	})),

	// Initialize grades state
	onInitGrades: (grades) => set(produce(state => {
		state.grades = grades;
	})),

	// Initialize blanks state
	onInitBlanks: (blanks) => set(produce(state => {
		state.blanks = blanks;
	})),

	// Reset store to initial state
	onReset: () => set({
		...GRADE_STUDENT_INITIAL
	})
}));